import SierraPartsXRefData from '../assets/itemXRef/redirect.json';

class SierraPartsXRefService {
  constructor() {
    this.items = SierraPartsXRefData.SierraPartsXRef.items;
  }

  getCustomerItemById(id) {
    const match = this.items.find(item => item.id === id.toString());
    return match ? match.catalogItem : null;
  }
}

const sierraPartsXRefService = new SierraPartsXRefService();
export default sierraPartsXRefService;
